import { Analytics } from './analytics';

let outboundUrl = $("a[href^='http']");

outboundUrl.click((e) => {
    Analytics.sendEvent('Outbound Links', $(e.currentTarget).attr('href'), window.location.pathname)
});